var map = {
	"./bubble-tail.svg": "./src/img/profile/bubble-tail.svg",
	"./joie-comics.png": "./src/img/profile/joie-comics.png",
	"./joie-pop.png": "./src/img/profile/joie-pop.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/img/profile sync \\.(png%7Cjpe?g%7Csvg)$";